module.exports = __webpack_public_path__ + "web/img/404_cloud.0f4bc32b.png";